import React from 'react';
import styled from 'styled-components';
import { FaClock, FaRoute, FaWalking } from 'react-icons/fa';
import { colors } from '../../../utils/theme';
import media from 'styled-media-query';
import { GQLTour, GQLWalk } from 'townapps-models';
import { useRouter } from 'next/router';
import getAmplitude from '../../../utils/amplitude';

type Props = {
  item: GQLWalk & GQLTour;
  shareOnTitle?: boolean;
  tags?: any[];
  withAuthor?: boolean;
};

const Wrapper = styled.div<{ walk: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  justify-content: ${p => (p.walk ? 'space-between' : 'flex-end')};
  margin-bottom: 24px;
  ${media.lessThan('small')`
        flex-direction: column;
        align-items: flex-start;
  `}
`;

const Difficulty = styled.p`
  font-weight: 600;
  font-size: 16px;
  margin: 0;
  ${media.lessThan('small')`
        width: 100%;
        margin-bottom: 16px;
  `}
`;

const TrailWalkData = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  width: 50%;
  justify-content: space-evenly;
  right: 0;
  ${media.lessThan('small')`
        width: 100%;
  `}
`;

const TrailWalkDataText = styled.p`
  margin-left: 16px;
  ${media.lessThan('small')`
        margin: 4px;
  `}
`;

const IconWrapper = styled.div`
  border: 1px solid ${colors.black};
  background-color: ${colors.white};
  height: 36px;
  width: 36px;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const TrailWalkDataWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const formatTime = (time: number) => {
  const leftNumber = Math.floor(time / 60);
  const rightNumber = time % 60;
  let toReturn = (rightNumber === 0 ? leftNumber : leftNumber + '.' + rightNumber) + ' Hrs';
  if (leftNumber === 0) {
    toReturn = rightNumber + ' Mins';
  }
  return toReturn;
};

const formatDistance = (distance: number) => {
  if (distance < 1000) return distance + ' M';
  const toReturn = distance / 1000 + ' Kms';
  return toReturn;
};

export const IconsActionsWalksTours = ({ item, noFaWalking = false, style = {} }) => {
  return (
    <TrailWalkData style={style}>
      <TrailWalkDataWrapper>
        <IconWrapper>
          <FaClock className="text-md" style={{ color: colors.black }} />
        </IconWrapper>
        <TrailWalkDataText>{formatTime(item?.time)}</TrailWalkDataText>
      </TrailWalkDataWrapper>
      <TrailWalkDataWrapper>
        <IconWrapper>
          <FaRoute className="text-md" style={{ color: colors.black }} />
        </IconWrapper>
        <TrailWalkDataText>{formatDistance(item?.distance)}</TrailWalkDataText>
      </TrailWalkDataWrapper>

      {noFaWalking ? null : (
        <TrailWalkDataWrapper>
          <IconWrapper
            onClick={async () => {
              window.open(`http://www.google.com/maps/place/${item?.latitude},${item?.longitude}`, '_blank');
              const amplitude = await getAmplitude();
              amplitude.logEvent('Clicked on listing directions', { itemType: item?.type });
            }}
            style={{
              backgroundColor: '#67d985',
              color: 'white',
              border: 0,
              cursor: 'pointer',
              boxShadow: '0 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 5px 8px 0px rgba(0, 0, 0, 0.14), 0px 1px 14px 0px rgba(0, 0, 0, 0.12)',
            }}>
            <FaWalking className="text-md" style={{ color: colors.black }} />
          </IconWrapper>
        </TrailWalkDataWrapper>
      )}
    </TrailWalkData>
  );
};

const TrailWalk: React.FC<Props> = ({ item }) => {
  const router = useRouter();
  return (
    <Wrapper walk={router.pathname.includes('/walks/[id]')}>
      {router.pathname.includes('/walks/[id]') ? <Difficulty>Dificulty: {item?.difficulty}</Difficulty> : null}

      <IconsActionsWalksTours item={item} />
    </Wrapper>
  );
};

export default TrailWalk;
